import { render, staticRenderFns } from "./physicalZip.vue?vue&type=template&id=7fcd6b9c&scoped=true&"
import script from "./physicalZip.vue?vue&type=script&lang=ts&"
export * from "./physicalZip.vue?vue&type=script&lang=ts&"
import style0 from "./physicalZip.vue?vue&type=style&index=0&id=7fcd6b9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fcd6b9c",
  null
  
)

export default component.exports